import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-policy-id-copy-button',
  templateUrl: './policy-id-copy-button.component.html',
  styleUrls: ['./policy-id-copy-button.component.css'],
})
export class PolicyIdCopyButtonComponent implements ICellRendererAngularComp {
  policyId: string | null = null;

  constructor(private readonly toastrService: ToastrService) {}

  agInit(params: ICellRendererParams): void {
    this.policyId = params.data.policyId ?? null;
  }

  refresh(): boolean {
    return false;
  }

  copy(): void {
    navigator.clipboard.writeText(this.policyId!);
    this.toastrService.success($localize`N° de police copié avec succès`);
  }
}
